import React from 'react';
import './clientDashboardCard.scss';
import { IsNewIcon } from '../../assets/images';

type AppProps = {
    name: string | undefined;
    description?: String | undefined;
    icon?: any;
    isNew:boolean;
    comingSoon?: boolean;
    action?: () => void;
}
const ClientDashboardCard = ({ name, icon, comingSoon, description, action , isNew }: AppProps) => {
    return (
        <div className={"client-dashboard-card " + (comingSoon && 'coming-soon-wrap')} onClick={action}>
            <div className="icon-block">
                {icon}
            </div>
            <div className="bg-icon-block">
                {icon}
            </div>
            <h4 className="text-left font-slick">
                {name}
            </h4>
            <p className="m-0">{description}</p>
            {/* <div className="viewIcon">A</div> */}
            {comingSoon ? <div className="coming-soon">Request Access</div> : null}
              
  
            {isNew ? <div className='new_icon'>
                <img src={IsNewIcon} alt="" />
            </div> :null}
        </div>
    )
}

export default ClientDashboardCard;